var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "#9598A7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.5H4C2.9 9.5 2 10.4 2 11.5V19.5C2 20.6 2.9 21.5 4 21.5H20C21.1 21.5 22 20.6 22 19.5V11.5C22 10.4 21.1 9.5 20 9.5ZM10 12.5C10.6 12.5 11 12.9 11 13.5C11 14.1 10.6 14.5 10 14.5C9.4 14.5 9 14.1 9 13.5C9 12.9 9.4 12.5 10 12.5ZM6 18.5C5.4 18.5 5 18.1 5 17.5C5 16.9 5.4 16.5 6 16.5C6.6 16.5 7 16.9 7 17.5C7 18.1 6.6 18.5 6 18.5ZM6 14.5C5.4 14.5 5 14.1 5 13.5C5 12.9 5.4 12.5 6 12.5C6.6 12.5 7 12.9 7 13.5C7 14.1 6.6 14.5 6 14.5ZM15 17.5C15 18 14.6 18.5 14.1 18.5H14H10C9.5 18.5 9 18.1 9 17.6V17.5C9 17 9.4 16.5 9.9 16.5H10H14C14.5 16.5 15 16.9 15 17.4V17.5ZM14 14.5C13.4 14.5 13 14.1 13 13.5C13 12.9 13.4 12.5 14 12.5C14.6 12.5 15 12.9 15 13.5C15 14.1 14.6 14.5 14 14.5ZM18 18.5C17.4 18.5 17 18.1 17 17.5C17 16.9 17.4 16.5 18 16.5C18.6 16.5 19 16.9 19 17.5C19 18.1 18.6 18.5 18 18.5ZM18 14.5C17.4 14.5 17 14.1 17 13.5C17 12.9 17.4 12.5 18 12.5C18.6 12.5 19 12.9 19 13.5C19 14.1 18.6 14.5 18 14.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 5.8L12.7 3.8C12.3 3.4 11.7 3.4 11.3 3.8L9.3 5.8C8.9 6.2 8.9 6.8 9.3 7.2C9.7 7.6 10.3 7.6 10.7 7.2L12 5.9L13.3 7.2C13.7 7.6 14.3 7.6 14.7 7.2C15.1 6.8 15.1 6.2 14.7 5.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.2cb15b40bf21751ffb17e551be9db7b8.svg";
export { ForwardRef as ReactComponent };